<template>
    <div class="page has-tab main">
        <div class="page-content">

            <transition name="fade">
                <index v-if="data.sel === 'index'" @jump="toggle('preBook')"/>
                <preBook v-else-if="data.sel === 'preBook'"/>
                <my v-else-if="data.sel === 'my'"/>
            </transition>
        </div>
        <div class="tab f-shark0">
            <div class="item main "
                 @click="toggle('index')"
                 :class="{'select': data.sel === 'index'}"></div>
            <div class="item buy"
                 @click="toggle('preBook')"
                 :class="{'select': data.sel === 'preBook'}"></div>
            <div class="item my"
                 @click="toggle('my')"
                 :class="{'select': data.sel === 'my'}"></div>
        </div>
    </div>
</template>

<script setup>
    import index from '../panel/index.vue';
    import preBook from '../panel/preBook.vue';
    import my from '../panel/my.vue';
    import t from '@zh-or/lib';
    import u from '@/lib/tools.js';

    import waitInit from '@/lib/init.js';

    import {ref, reactive, onMounted} from 'vue';

    let data = reactive({
        sel: t.getLocal('tab', 'index')
    })

    waitInit(() => {

    });

    onMounted(() => {
       let to = t.getQueryString('to');
       if(to) {
           toggle(to);
       }
    });

    function toggle(str) {
        data.sel = str;
        t.setLocal('tab', str);
    }

</script>

<style lang="scss">
    .main {

        .tab {
            .main {
                background: url("~@/assets/icons/main.png") no-repeat center center;
                background-size: auto 80%;

                &.select {
                    background-image: url("~@/assets/icons/main-s.png");
                }
            }
            .buy {
                background: url("~@/assets/icons/buy.png") no-repeat center center;
                background-size: auto 80%;

                &.select {
                    background-image: url("~@/assets/icons/buy-s.png");
                }
            }
            .my {
                background: url("~@/assets/icons/my.png") no-repeat center center;
                background-size: auto 80%;

                &.select {
                    background-image: url("~@/assets/icons/my-s.png");
                }
            }

        }
    }
</style>
